import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoaderService } from './shared/services/loader.service';
import { CustomerDetailsService } from './core/services/customer-details.service';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
// import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
// import { NavBigComponent } from './layout/nav-big/nav-big.component';
// import { NavSmallComponent } from './layout/nav-small/nav-small.component';
// import { LogoComponent } from './layout/logo/logo.component';
// import { LoaderComponent } from './shared/components/loader/loader.component';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { CacheRegistrationService } from './shared/services/cache-registration.service';
import { UriCachingInterceptor } from './core/interceptors/uri-caching.interceptor';
import { OnlyLoggedInUsersGuard } from './shared/guards/OnlyLoggedInUsersGuard';
// import { DashboardService } from './shared/services/dashboard.service';
import { DatePipe } from '@angular/common';
// import {NgxPaginationModule} from 'ngx-pagination';
// import { DialogBoxComponent } from 'src/app/shared/components/dialog-box/dialog-box.component';
// import { ErrorComponent } from './shared/components/error/error.component';
// import { AlphanumericDirective } from './shared/directives/alphanumeric.directive';
// import { OnlyNumbersDirective } from './shared/directives/only-numbers.directive';
// import { ErrorComponent } from './shared/components/error/error.component';
// import { ShowHidePasswordComponent } from 'ngx-show-hide-password';
import { SvtService } from './core/services/svt.service';
import { DashboardService } from './shared/services/dashboard.service';
// import { HistoryTableComponent } from './shared/components/history-table/history-table.component';
// import { RecordActionComponent } from './modules/customer-dashboard/components/record-action/record-action.component';
import { SharedModule } from './shared/shared.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule  } from '@angular/fire/compat/firestore';
import { environment } from '../environments/environment';
import { DongleDeviceComponent } from './modules/device-mapping/dongle-device/dongle-device.component';
import { NewDeviceComponent } from './modules/device-mapping/dongle-device/new-device/new-device.component';
import { DongleDeviceRoutingModule } from './modules/device-mapping/dongle-device/dongle-device-routing.module';
// import { DeviceMappingComponent } from './modules/device-mapping/device-mapping.component';
// import { provideFirebaseApp, initializeApp } from '@angular/fire/app';

@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent,
        // DeviceMappingComponent,
        // ContentLayoutComponent,
        // LogoComponent,
        // NavBigComponent,
        // NavSmallComponent,
        // LoaderComponent,
        // AlphanumericDirective,
        // OnlyNumbersDirective,
        // DialogBoxComponent,
        // ErrorComponent
        // HistoryTableComponent
        // ErrorComponent,
        // RecordActionComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        // HttpClientModule,
        // FormsModule,
        // ReactiveFormsModule,
        SharedModule,
        BsDatepickerModule,
        // DatepickerModule.forRoot(),
        BrowserAnimationsModule,
        // NgxPaginationModule,
        // ShowHidePasswordModule,
        AngularFireModule.initializeApp(environment.firebase),
        // provideFirebaseApp(() => initializeApp(environment.firebase)),
        AngularFirestoreModule,
        NgbModule
        // ShowHidePasswordComponent

    ],
    providers: [
        LoaderService,
        CacheRegistrationService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: UriCachingInterceptor, multi: true },
        CustomerDetailsService,
        OnlyLoggedInUsersGuard,
        DashboardService,
        SvtService,
        DashboardService,
        DatePipe,
    ],
    exports: [
        // DialogBoxComponent,
        SharedModule
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
